import {Colors, home, personalData} from './constants'

const navBar = {
    show: true
}

const mainBody = {
    firstName: 'Felipe',
    gradientColors: Colors.HeroGradient.Sky,
    icons: [
        {
            image: 'fa-github',
            url: 'https://github.com/felipechava'
        },
        {
            image: 'fa-instagram',
            url: 'https://www.instagram.com/felipechavaa/'
        },
        {
            image: 'fa-linkedin',
            url: 'https://www.linkedin.com/in/felipechavaa/'
        }
    ],
    lastName: 'Chavarria',
    message: 'I’m Felipe, turning ideas into digital products | Full-Stack Developer | React, .NET & Cloud',
    middleName: 'Manuel',
    secondLastName: 'Benitez'
}

/*                                      ABOUT SECTION

If you want the About Section to show a profile picture you can fill the profilePictureLink either with:

    a) your Instagram username
        i.e:profilePictureLink:"johnDoe123",

    b) a link to a hosted image
        i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",

    c) image in "editable-stuff" directory and use require("") to import here,
        i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),

    d) If you do not want any picture to be displayed, just leave it empty :)
        i.e: profilePictureLink: "",

For Resume either provide link to your resume or import from "editable-stuff" directory
    i.e
    resume: require("../editable-stuff/resume.pdf"),
    resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",*/

const about = {
    heading: 'About Me',
    imageLink: require('../editable-stuff/myself.jpeg'),
    imageSize: 375,
    message: home.aboutMeDescription,
    resume: 'https://drive.google.com/file/d/1zOBSyM8qc6VyN3UopQ6RNWEUfEzJbPLF/view?usp=sharing',
    show: true
}

/*                                  PROJECTS SECTION

Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
    i.e: reposLength: 0

If you want to display specfic projects, add the repository names,
    i.e: ["repository-1", "repo-2"] and reposLength at 0 */

const repos = {
    gitHubUsername: 'felipechava',
    heading: 'Projects',
    reposLength: 0,
    show: true,
    specificRepos: ['MY-CV', 'SocialNetworkProject']
}

// LEADERSHIP SECTION
const leadership = {
    heading: 'Leadership',
    show: false,
    images: [
        {
            img: require('../editable-stuff/myself.jpeg'),
            label: 'First slide label',
            paragraph: 'Nulla vitae elit libero, a pharetra augue mollis interdum.'
        },
        {
            img: require('../editable-stuff/myself.jpeg'),
            label: 'Second slide label',
            paragraph: 'Nulla vitae elit libero, a pharetra augue mollis interdum.'
        }
    ],
    imageSize: {
        width: '615',
        height: '450'
    },
    message:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ' +
        'aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. ' +
        'Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet ' +
        'non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ' +
        'ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse ' +
        'interdum consectetur libero.'
}

// SKILLS SECTION
const skills = {
    hardSkills: [
        {name: 'C#', value: 70},
        {name: 'JavaScript', value: 55},
        {name: 'React', value: 50},
        {name: 'HTML/CSS', value: 40},
        {name: 'SQL', value: 30},
        {name: 'Cloud Azure', value: 15}
    ],
    heading: 'Skills',
    show: true,
    softSkills: [
        {name: 'Problem Solving', value: 70},
        {name: 'Goal-Oriented', value: 90},
        {name: 'Creativity', value: 40},
        {name: 'Continuous Learning', value: 100},
        {name: 'Interpersonal Skills', value: 80},
        {name: 'Self Motivation', value: 70}
    ]
}

// GET IN TOUCH SECTION
const getInTouch = {
    email: personalData.email,
    heading: 'Get In Touch',
    message: 'Please, if you have any questions or if you just want to say hi, feel free to email me at',
    show: true
}

// EXPERIENCES SECTION
const experiences = {
    data: [
        {
            companyLogo: require('../assets/img/protect group_full_logo.png'),
            companyName: 'Protect Group',
            companyUrl: 'https://www.protect.group',
            roles: [
                {
                    endDate: '2025-12-31',
                    role: 'Software Developer',
                    startDate: '2024-02-26'
                },
                {
                    endDate: null,
                    role: 'Software Engineer',
                    startDate: '2026-01-01'
                }
            ]
        }
    ],
    heading: 'Experience',
    show: true
}

export {
    about,
    experiences,
    getInTouch,
    leadership,
    navBar,
    mainBody,
    repos,
    skills
}